import React, { useState, useEffect } from 'react';
// import axios from 'axios';
import addProductCSS from './addProduct.module.css';
import Loader from '../../loader';
import { axiosAuthFetch } from '../../../helpers/apiActions/authFetch';
import { axiosImageAuthFetch } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import serviceForm from '../../serviceForm/serviceForm.module.css';


function AddProductForm() {
    const [file, setFile] = useState(null);
    const [file2, setFile2] = useState(null);
    const [productName, setProductName] = useState('');
    const [productPrice, setProductPrice] = useState('');
    const [productDescription, setProductDescription] = useState('');
    const [productVarenummer, setProductVarenummer] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplierId, setSelectedSupplierId] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [productInformationList, setProductInformationList] = useState([{text: "", value: ""}])
    const [checks, setChecks] = useState([{ id: 1, description: '', category: '' }]);
    const [newCategoryName, setNewCategoryName] = useState('');
    const [checkCategories, setCheckCategories] = useState([{ id: 1, name: '' }]);
    const [visualChecked, setVisualChecked] = useState(false);
    const [hasVoltageOptions, setHasVoltageOptions] = useState(false);
    const [voltageOptions, setVoltageOptions] = useState([{ voltage: "" }]);

    useEffect(() => {
        async function fetchSuppliers() {
            try {
                const response = await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/suppliers?pagination[pageSize]=50&sort=name:asc');
                setSuppliers(response.data);

                const categoryResponse = await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/categories?sort=place:asc');
                setCategories(categoryResponse.data);
            } catch (error) {
                console.error(error);
            }
        }

        fetchSuppliers();
    }, []);

    const handleSupplierChange = (event) => {
        setSelectedSupplierId(event.target.value);
    };
    const handleCategoryChange = (event) => {
        setSelectedCategoryId(event.target.value);
    };

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const handleVisibilityChange = () => {
        setIsVisible(!isVisible);
    }

    const handleFile2Change = (event) => {
        setFile2(event.target.files[0]);
    };

    const handleProductNameChange = (event) => {
        setProductName(event.target.value);
    };
    const handleProductDescriptionChange = (event) => {
        setProductDescription(event.target.value);
    };
    const handleProductVarenummerChange = (event) => {
        setProductVarenummer(event.target.value);
    };
    const handleProductPriceChange = (event) => {
        setProductPrice(event.target.value);
    }

    const handleAddCheck = () => {
        const newCheckId = checks.length + 1;
        setChecks([...checks, { id: newCheckId, description: '', category: '' }]);
    };

    const handleCheckDescriptionChange = (id, description) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, description } : check
            );
            return updatedChecks;
        });
    };

    const handleAddCategory = () => {
        if (newCategoryName.trim() !== '') {
            const newCategoryId = checkCategories.length + 1;
            setCheckCategories([...checkCategories, { id: newCategoryId, name: newCategoryName.trim() }]);
            setNewCategoryName('');
        }
    };

    const handleCategoryNameChange = (e) => {
        setNewCategoryName(e.target.value);
    };

    const handleCheckCategoryChange = (id, category) => {
        setChecks(prevChecks => {
            const updatedChecks = prevChecks.map(check =>
                check.id === id ? { ...check, category } : check
            );
            return updatedChecks;
        });
    };

    const handleRemoveCheck = (id) => {
        const updatedChecks = checks.filter(check => check.id !== id);
        setChecks(updatedChecks);
    };

    const handleProductInformationChange = (index, field, value) => {
        const newProductInformationList = [...productInformationList];
        newProductInformationList[index][field] = value;
        setProductInformationList(newProductInformationList);
    }

    const handleAddProductInformation = (event) => {
        event.preventDefault();
        setProductInformationList([...productInformationList, {type:"",value:""}]);
    }

    const handleRemoveProductInformation = (index) => {
        const newProductInformationList = productInformationList.filter((_,i) => i !== index);
        setProductInformationList(newProductInformationList);
    }

    const handleAddVoltageOption = (event) => {
        event.preventDefault();
        setVoltageOptions([...voltageOptions, { voltage : "" }]);
    };

    const handleRemoveVoltageOption = (index) => {
        const newVoltageOptions = voltageOptions.filter((_, i) => i !== index);
        setVoltageOptions(newVoltageOptions);
    };

    const handleVoltageOptionsChange = (index, value) => {
        const newVoltageOptions = [...voltageOptions];
        newVoltageOptions[index].voltage = value;
        setVoltageOptions(newVoltageOptions);
    };

    const createCheck = async (description, category) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-checks`, {
                data: {
                    description: description,
                    category: category,
                }
            }, 'POST');
            return response.data.id;
        } catch (error) {
            console.error(error);
        }
    };

    const createServiceForm = async (productID, checkIDs) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms`, {
                data: {
                    visual_check: false,
                    product: productID,
                    service_checks: {
                        connect: checkIDs
                    }
                }
            }, 'POST');
            return response.data;
        } catch (error) {
            console.error(error)
        }
    }

    const createVisualServiceForm = async (productID, checkID) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-forms`, {
                data: {
                    product: productID,
                    visual_check: true,
                    service_checks: {
                        connect: checkID
                    }
                }
            }, 'POST');
            return response.data;
        } catch (error) {
            console.error(error)
        }
    }

    const createServiceAction = async (checkID, formID) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/service-actions`, {
                data: {
                    completed: false,
                    service_check: {
                        connect: [checkID]
                    },
                    service_form: {
                        connect: [formID]
                    }
                }
            }, 'POST');
            return response.data.id;
        } catch (error) {
            console.error(error);
            return null;
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const filteredProductInformationList = productInformationList.filter(info => info.text.trim() !== "" && info.value.trim() !== "");

        if (!validateProductInformation(filteredProductInformationList)) {
            //setErrorMessage("Alle felter må ha minst 3 tegn.");
            setIsLoading(false);
            return;
        }

        const priceToSend = productPrice === '' ? null : parseFloat(productPrice);

        try {
            const productData = {
                "data": {
                    "name": productName,
                    "description": productDescription,
                    "price": priceToSend,
                    "visible": isVisible,
                    "varenummer": productVarenummer,
                    "product_information": productInformationList.map(info => ({
                        infoText: info.text,
                        infoValue: info.value,
                    })),
                    "multipleVoltages": hasVoltageOptions,
                    "voltageOptions": voltageOptions.filter(option => option.voltage.trim() !== "")
                },
            };

            const productResponse = await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/products', productData, 'post');
            const productID = productResponse.data.id;

            const supplierData = {
                "data": {
                    supplier: {
                        connect: [selectedSupplierId]
                    },
                    category: {
                        connect: [selectedCategoryId]
                    },
                }
            }

            const populateWithSupplierURL = await axiosAuthFetch(`https://renowned-oasis-58a898da10.strapiapp.com/api/products/${productID}`, supplierData, 'put');
            console.log(populateWithSupplierURL);
            const imageData = new FormData();
            imageData.append('ref', 'api::product.product');
            imageData.append('refId', productID);
            imageData.append('field', 'image');
            imageData.append('files', file);

            const imageResponse = await axiosImageAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/upload', imageData);
            console.log(imageResponse);
            const image2Data = new FormData();
            image2Data.append('ref', 'api::product.product');
            image2Data.append('refId', productID);
            image2Data.append('field', 'produktKatalog');
            image2Data.append('files', file2);

            const image2Response = await axiosImageAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/upload', image2Data);
            console.log(image2Response);

            const checkIDs = [];
            for (const check of checks) {
                const checkID = await createCheck(check.description, check.category);
                checkIDs.push(checkID);
            }

            if (visualChecked) {
                const visualID = [119];
                const createdServiceForm = await createVisualServiceForm(productID, visualID);
                const serviceFormId = createdServiceForm.id;
                const serviceActionComplete = await createServiceAction(119, serviceFormId);
                console.log(serviceActionComplete);
            } else {
                const createdServiceForm = await createServiceForm(productID, checkIDs);
                const serviceFormId = createdServiceForm.id;

                for (const checkID of checkIDs) {
                    await createServiceAction(checkID, serviceFormId);
                }
            }

            setIsLoading(false);
            alert('Produkt og service skjema opprettet!');
            window.location.href = "/VP/admin/nettbutikk";
        } catch (error) {
            console.error('Feil ved opplasting av bilde eller innsending av skjemadata:', error);
            setIsLoading(false);
        }
    };

    const validateProductInformation = (productInformationList) => {
        return productInformationList.every(info => info.text.length >= 3 && info.value.length >= 3);
    };

    const handleCheck = () => {
        setVisualChecked(!visualChecked);
    }

    const handleMulitpleVoltages = () => {
        setHasVoltageOptions(!hasVoltageOptions);
    }

    const formatCategoryName = (name) => {
        return name.replace(/_/g, ' ');
    }

    return (
        <div>
            {isLoading && <Loader />}
            <div className={addProductCSS.p}>
                <h2>Opprett nytt produkt</h2>
            </div>
            <form className={addProductCSS.form} onSubmit={handleSubmit}>
                <input className={addProductCSS.input} type="text" value={productName} onChange={handleProductNameChange} placeholder="Produktnavn" required />
                <textarea className={addProductCSS.textAreaInput} type="text" value={productDescription} onChange={handleProductDescriptionChange} placeholder="Produktbeskrivelse" rows={7} />
                <input className={addProductCSS.input} type="text" value={productPrice} onChange={handleProductPriceChange} placeholder="Pris" />
                <input className={addProductCSS.input} type="text" value={productVarenummer} onChange={handleProductVarenummerChange} placeholder="Varenummer" />
                <select className={addProductCSS.select} value={selectedSupplierId} onChange={handleSupplierChange} required>
                    <option value="">Velg leverandør</option>
                    {suppliers.map(supplier => (
                        <option key={supplier.id} value={supplier.id}>{supplier.attributes.name}</option>
                    ))}
                </select>
                <select className={addProductCSS.select} value={selectedCategoryId} onChange={handleCategoryChange} required>
                    <option value="">Velg kategori/plassering</option>
                    {categories.map(category => (
                        <option key={category.id} value={category.id}>{formatCategoryName(category.attributes.place)}</option>
                    ))}
                </select>
                <h3 className={addProductCSS.h3}>Produktbilde</h3>
                <input className={addProductCSS.fileInput} type="file" onChange={handleFileChange} />
                <h3 className={addProductCSS.h3}>Datablad</h3>
                <input className={addProductCSS.fileInput} type="file" onChange={handleFile2Change} />
                <div className={addProductCSS.visibilityContainer}>
                    <div className={addProductCSS.visibilityChild1}>
                        Synlig i nettbutikken
                    </div>
                    <div className={`${addProductCSS.visibilityChild2} ${isVisible ? addProductCSS.checked : ''}`} onClick={handleVisibilityChange}>
                        <div className={addProductCSS.visibilityButton}></div>
                    </div>
                </div>
                <h3 className={addProductCSS.h3}>Teknisk info</h3>
                {productInformationList.map((info, index) => (
                    <div key={index} className={addProductCSS.inputGroup}>
                        <div className={addProductCSS.inputSub}>
                            <input
                            className={addProductCSS.input}
                            type="text"
                            value={info.text}
                            onChange={(e) => handleProductInformationChange(index, "text", e.target.value)}
                            placeholder="Type"
                            />
                            <input
                            className={addProductCSS.input}
                            type="text"
                            value={info.value}
                            onChange={(e) => handleProductInformationChange(index, "value", e.target.value)}
                            placeholder="Verdi"
                            />
                        </div>
                        <button type="button" className={serviceForm.removeButton} onClick={() => handleRemoveProductInformation(index)}>Fjern</button>
                    </div>
                    ))}
                    <button className={`${serviceForm.addButton} mt-1 bg-success text-white`} type="button" onClick={handleAddProductInformation}>Legg til ny teknisk info</button>
                    <div className={addProductCSS.spenningsContainer}>
                    <h3 className={addProductCSS.h3}>Spenningstyper</h3>
                    <div className={addProductCSS.subContainer1}>
                        <div>Flere spenningstyper</div>
                            <div className={`${serviceForm.visuellSjekkButton} ${hasVoltageOptions ? serviceForm.checked : ''}`} onClick={handleMulitpleVoltages}>
                                <div className={serviceForm.running}></div>
                            </div>
                        </div>
                </div>

                {hasVoltageOptions && (
                    <>
                        {voltageOptions.map((option, index) => (
                            <div key={index} className={addProductCSS.inputGroup}>
                                <input
                                    className={addProductCSS.input}
                                    type="text"
                                    value={option.voltage}
                                    onChange={(e) => handleVoltageOptionsChange(index, e.target.value)}
                                    placeholder="Volt"
                                />
                                <button className={`${serviceForm.removeButton} my-2`} type="button" onClick={() => handleRemoveVoltageOption(index)}>Fjern</button>
                            </div>
                        ))}
                        <button className={`${serviceForm.addButton} bg-success text-white`} type="button" onClick={handleAddVoltageOption}>Legg til spenningstype</button>
                    </>
                )}
                <h2 className='mt-5 mb-3'>SERVICE</h2>
                <div className={serviceForm.container1}>
                    <div className={serviceForm.container7}>
                        <div className={serviceForm.visuellSjekk}>
                            Visuell sjekk
                        </div>
                        <div className={`${serviceForm.visuellSjekkButton} ${visualChecked ? serviceForm.checked : ''}`} onClick={handleCheck}>
                            <div className={serviceForm.running}></div>
                        </div>
                    </div>
                    {!visualChecked && (
                        <>
                            <div className={serviceForm.categoryButtonDiv}>
                                <label>Kategori / underoverskrift</label>
                                <div className={serviceForm.container5}>
                                    <input
                                        type="text"
                                        value={newCategoryName}
                                        onChange={handleCategoryNameChange}
                                        placeholder="Skriv inn kategorinavn"
                                    />
                                    <button className={`${serviceForm.addButton} mt-2 bg-success text-white`} type="button" onClick={handleAddCategory}>
                                        Legg til overskrift
                                    </button>
                                </div>
                            </div>
                            {checks.map((check, index) => (
                                <div className={serviceForm.container2} key={`${check.id}-${index}`}>
                                    <label>Sjekk nummer {index + 1}</label>
                                    <div className={addProductCSS.container3}>
                                        <input
                                            className={serviceForm.input}
                                            type="text"
                                            value={check.description}
                                            onChange={e => handleCheckDescriptionChange(check.id, e.target.value)}
                                        />
                                        <button className={`${serviceForm.removeButton} my-2`} type="button" onClick={() => handleRemoveCheck(check.id)}>
                                            Fjern
                                        </button>
                                        <div className={serviceForm.container6}>
                                            <select
                                                value={check.category}
                                                onChange={e => handleCheckCategoryChange(check.id, e.target.value)}
                                            >
                                                <option value="">Velg kategori</option>
                                                {checkCategories.map(category => (
                                                    <option key={category.id} value={category.name}>
                                                        {category.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <button className={`${serviceForm.addButton} mt-2 bg-success text-white`} type="button" onClick={handleAddCheck}>
                                Legg til sjekk
                            </button>
                        </>
                    )}
                </div>
                
                <button className={`${addProductCSS.button} ${addProductCSS.opprettButton}`} type="submit">Opprett</button>
            </form>
        </div>
    );
}

export default AddProductForm;




































































// import React, { useState } from 'react';
// import axios from 'axios';

// function UploadImageForm({ handleImageSubmit }) {
//     const [file, setFile] = useState(null);

//     const handleFileChange = (event) => {
//         setFile(event.target.files[0]);
//     };

//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         await handleImageSubmit(file);
//     };

//     return (
//         <form onSubmit={handleSubmit}>
//             <input type="file" onChange={handleFileChange} />
//             {/* <button type="submit">Upload Image</button> */}
//         </form>
//     );
// }

// function UploadDataForm({ handleDataSubmit }) {
//     const [productName, setProductName] = useState('');

//     const handleProductNameChange = (event) => {
//         setProductName(event.target.value);
//     };

//     const handleSubmit = (event) => {
//         event.preventDefault();
//         handleDataSubmit(productName);
//     };

//     return (
//         <form onSubmit={handleSubmit}>
//             <input
//                 type="text"
//                 placeholder="Product Name"
//                 value={productName}
//                 onChange={handleProductNameChange}
//             />
//             {/* <button type="submit">Submit Data</button> */}
//         </form>
//     );
// }

// export function AddProductForm() {
//     const handleImageSubmit = async (file) => {
//         // Opprett et FormData-objekt for å legge til bildet
//         const imageData = new FormData();
//         imageData.append('files', file);
    
//         try {
//             // Utfør et POST-forespørsel til API-endepunktet for opplasting av bildet
//             const response = await axios.post('https://renowned-oasis-58a898da10.strapiapp.com/api/upload', imageData);
    
//             // Hvis opplastingen var vellykket, kan du logge bildedataene
//             console.log('Bilde opplastet:', response.data);
//         } catch (error) {
//             // Hvis det oppstår en feil under opplastingen, logg feilmeldingen
//             console.error('Feil ved opplasting av bilde:', error);
//         }
//     };

//     const handleDataSubmit = async (productName) => {
//         // Handle data submission logic here
//         console.log('Submitting data:', productName);
//     };

//     return (
//         <div>
//             <UploadImageForm handleImageSubmit={handleImageSubmit} />
//             <UploadDataForm handleDataSubmit={handleDataSubmit} />
//         </div>
//     );
// }


// import React, { useState } from 'react';
// import axios from 'axios';

// function UploadImageForm() {
//     const [file, setFile] = useState(null);

//     const handleFileChange = (event) => {
//         console.log(event.target.files);
//         setFile(event.target.files[0])
//     };

//     return(
//         <form>
//             <input onChange={handleFileChange} type="file" />
//         </form>
//     )
// }

// function UploadDataForm() {
//     const [productName, setProductName] = useState('');
//     // const [productDescription, setProductDescription] = useState('');
//     // const [productPrice, setProductPrice] = useState('');
//     // const [productVarenummer, setProductVarenummer] = useState('');
//     // const [productWeight, setProductWeight] = useState('');
//     // const [productEnige, setProductEngine] = useState('');

    

//     const handleProductNameChange = (event) => {
//         setProductName(event.target.value);
//     }
//     // const handleProductDescriptionhange = (event) => {
//     //     setProductDescription(event.target.value);
//     // }
//     // const handleProductPriceChange = (event) => {
//     //     setProductPrice(event.target.value);
//     // }
//     // const handleProductVarenummerChange = (event) => {
//     //     setProductVarenummer(event.target.value);
//     // }
//     // const handleProductWeightChange = (event) => {
//     //     setProductWeight(event.target.value);
//     // }
//     // const handleProductEngineChange = (event) => {
//     //     setProductEngine(event.target.value);
//     // };

//     return (
//         <form>
//             <input 
//             type="text" 
//             name="name" 
//             placeholder="Produktnavn" 
//             onChange={handleProductNameChange}
//             required />
//         </form>
//     )
// }

// function CombinedForm() {
//     const handleImageSubmit = async (imageData) => {
//         const data = new FormData();
//         data.append('files', file);

//         const upload_res = await axios({
//             method: 'POST',
//             url: 'https://renowned-oasis-58a898da10.strapiapp.com/api/upload',
//             data
//         });
//     }
// }

// export function AddProductForm() {


//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         console.log('dette er file', file);

//         const data = new FormData();
//         data.append('files', file);

//         const upload_res = await axios({
//             method: 'POST',
//             url: 'https://renowned-oasis-58a898da10.strapiapp.com/api/upload',
//             data
//         });

//         console.log(upload_res);
//         console.log(upload_res.data[0].id);
//         console.log(upload_res.data[0].url);
//         const image_url = upload_res.data[0].url;
//     };



//     return(
//         <div>
//             <form onSubmit={handleSubmit}>
//                 <input type="text" name="name" />
//                 <button>Submit</button>
//             </form>
//         </div>
//     )
// }









// import React from 'react';

// import { useState } from 'react';

// export function AddProductForm() {
//     const [formData, setFormData] = useState({});
//     const [image, setImage] = useState(null);
    
//     const handleInputChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleImageChange = (e) => {
//         setImage(e.target.files[0]);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const form = e.target;
//         const formData = new FormData(form);

//         Object.entries(formData).forEach(([key, value]) => {
//             formData.append(key, value);
//         });

//         if (image) {
//             formData.append('files.image', image, image.name);
//         }

//         console.log(formData);

//         const response = await fetch('https://renowned-oasis-58a898da10.strapiapp.com/api/products', {
//             method: 'POST',
//             body: formData,
//         });

//         const result = await response.json();
//         console.log(result);
//     };

//     return (
//         <div>
//             <h2>Opprett nytt produkt</h2>
//             <form id="addProductForm" onSubmit={handleSubmit} encType="multipart/form-data">
//                 <input type="text" name="name" placeholder="produktnavn" onChange={handleInputChange} required />
//                 <input type="text" name="description" placeholder="produktbeskrivelse" onChange={handleInputChange} required />
//                 <input type="text" name="price" placeholder="produktpris" onChange={handleInputChange} required />
//                 <input type="text" name="varenummer" placeholder="varenummer" onChange={handleInputChange} required />
//                 <input type="text" name="packaging" placeholder="packaging" onChange={handleInputChange} />
//                 <input type="file" name="image" onChange={handleImageChange} />
//                 <button type="submit">Opprett produkt</button>
//             </form>
//         </div>
//     );
// }








//import React, { useState } from 'react';
//import useCreateProduct from '../../../hooks/addProduct';


// export function AddProductForm() {
//     const {loading, error, product, createProduct} = useCreateProduct();
//     const [file, setFile] = useState(null);

//     async function handleSubmit(event) {
//         event.preventDefault();
//         const formData = new FormData(event.target);
//         formData.append('files', file);

//         // const technicalInfo = {
//         //     "vekt" : formData.get('vekt'),
//         //     "power": formData.get('power'),
//         //     "engine": formData.get('engine'),
//         //     "fullWidth": formData.get('fullWidth'),
//         //     "fullHeight": formData.get('fullHeight'),
//         //     "armHeight": formData.get('armHeight'),
//         //     "packaging": formData.get('packaging'),
//         // };


//         // const productData = {
//         //     "data": {
//         //     "name": formData.get('name'),
//         //     "description": formData.get('description'),
//         //     "price": parseFloat(formData.get('price')),
//         //     "varenummer": formData.get('varenummer'),
//         //     "technical_info": technicalInfo,
//         //     "image": files,
//         // }};

//         console.log(formData);
//         createProduct(formData);
//     }

//     function handleImageChange(event) {
//         setFile({files: event.target.files[0]});
//     }

//     return(
//         <div>
//             <h2>Opprett nytt produkt</h2>
//             <form className={addProductCSS.form} onSubmit={handleSubmit}>
//                 <input className={addProductCSS.input} type="text" name="name" placeholder="produktnavn" required />
//                 <input className={addProductCSS.input} type="text" name="description" placeholder="produktbeskrivelse" required />
//                 <input className={addProductCSS.input} type="text" name="price" placeholder="produktpris" required />
//                 <input className={addProductCSS.input} type="text" name="varenummer" placeholder="varenummer" required />
//                 {/* <input className={addProductCSS.input} type="text" name="packaging" placeholder="packaging" /> */}
//                 <input className={addProductCSS.input} type="file" name="files" onChange={handleImageChange} />
//                 <button className={addProductCSS.button} type="submit" disabled={loading}>
//                     {loading ? 'Creating...' : 'Opprett produkt'}
//                 </button>
//             </form>
//             {error && <p>Error: {error}</p>}
//             {product && <p>Produkt opprettet!</p>}
//         </div>
//     )
// }

// export default AddProductForm;




// import React, { useState } from 'react';
// import useCreateProduct from '../../../hooks/addProduct';
// import addProductCSS from './addProduct.module.css';

// export function AddProductForm() {
//   const { loading, error, product, createProduct } = useCreateProduct();
//   const [formData, setFormData] = useState(new FormData()); // Use formData for all fields

//   const handleChange = (event) => {
//     const { name, type, value, files } = event.target;
//     if (!['submit', 'file'].includes(type)) {
//       setFormData((prevData) => ({ ...prevData, [name]: value })); // Update formData for non-file fields
//     } else if (type === 'file') {
//       files.forEach((file) => {
//         setFormData((prevData) => ({ ...prevData, [`files.${name}`]: file })); // Update formData for file fields
//       });
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     try {
//       // Call your useCreateProduct hook, passing formData
//       await createProduct(formData);

//       console.log('Product created successfully:', product); // Assuming product data is returned
//       // Implement success handling (e.g., display success message, redirect)
//     } catch (error) {
//       console.error('Error creating product:', error);
//       // Implement error handling (e.g., display error message)
//     }
//   };

//   return (
//     <div>
//       <h2>Opprett nytt produkt</h2>
//       <form className={addProductCSS.form} onSubmit={handleSubmit}>
//         <input className={addProductCSS.input} type="text" name="name" placeholder="produktnavn" required />
//         <input className={addProductCSS.input} type="text" name="description" placeholder="produktbeskrivelse" required />
//         <input className={addProductCSS.input} type="text" name="price" placeholder="produktpris" required />
//         <input className={addProductCSS.input} type="text" name="varenummer" placeholder="varenummer" required />
//         <input className={addProductCSS.input} type="text" name="packaging" placeholder="packaging" />
        
//         <input
//           className={addProductCSS.input}
//           type="file"
//           name="image"
//           onChange={handleChange}
//         />
//         {/* ... other fields */}
//         <button className={addProductCSS.button} type="submit" disabled={loading}>
//           {loading ? 'Creating...' : 'Opprett produkt'}
//         </button>
//       </form>
//       {error && <p>Error: {error}</p>}
//       {product && <p>Produkt opprettet!</p>}
//     </div>
//   );
// }

// export default AddProductForm;